import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { PopupMessage } from "./PopupMessage";

interface DisclaimerProps {
  onClick: () => void;
  title?: string;
  text?: string[]
}

const Content = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={{ mb: 1 }}>
      {children}
    </Typography>
  );
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ onClick, title = '', text = [] }) => (
  <PopupMessage title={title} onClose={onClick}>
    {text.map(paragraph => (<Content key={paragraph}>{paragraph}</Content>))}
  </PopupMessage>
);